module.exports = __webpack_public_path__ + "static/media/k_black.8aa6a37d.png";